import { createSlice } from "@reduxjs/toolkit"
import moment from "moment"
import { AFFECTED_PARTICIPANT_FILTER, DEPARTMENT_FILTER, DETAILS_OVERALL_RECOMMENDATIONS_FILTERS, SEVERITY_FILTER } from "../../utilities/constants"

const DetailsRecommendationSlice = createSlice({
  name: "DETAILS_RECOMMENDATIONS",
  initialState: {
    filters: {
      [DETAILS_OVERALL_RECOMMENDATIONS_FILTERS.DEPARTMENT]: DEPARTMENT_FILTER.ALL,
      [DETAILS_OVERALL_RECOMMENDATIONS_FILTERS.AFFECTED_PARTICIPANTS]: AFFECTED_PARTICIPANT_FILTER.HIGHEST,
      [DETAILS_OVERALL_RECOMMENDATIONS_FILTERS.FINDING_SEVERITY]: SEVERITY_FILTER.HIGHEST,
    },
    searchText: "",
    currentHistoricalDate: null,
  },
  reducers: {
    // Search Actions
    setSearchText: (state, action) => {
      const _searchText = action?.payload
      state.searchText = typeof _searchText === "string" ? _searchText.trim() : ""
    },

    // Filter Actions
    // action.payload to be like { filterParam: string, filterValue: string | string[] }
    setFilters: (state, action) => {
      const filterKey = action?.payload.filterParam
      const filterValue = action?.payload.filterValue
      const filters = { ...state.filters }
      if (Object.keys(state.filters).includes(filterKey)) {
        filters[filterKey] = filterValue
      }
      state.filters = { ...filters }
    },

    // Updated Historical Date can be set here
    // action.payload to be like { currentDate: null | ISO Date string }
    setCurrentHistoricalDate: (state, action) => {
      const { date } = action.payload
      if (date && moment(date).isValid()) {
        state.currentHistoricalDate = date
      } else {
        state.currentHistoricalDate = null
      }
    },
  },
})

export const DetailsRecommendationsActions = DetailsRecommendationSlice.actions
export default DetailsRecommendationSlice
